import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ResponseDialogComponent } from '@app/@shared/dialogs/response/response-dialog.component';
import { LoaderGenericService } from '@app/@shared/loader-generic/loader-generic.service';
import { DetectDeviceService } from '@app/@shared/services/utils/detect-device.service';
import { DigitalSignatureServiceStore } from '@app/requests/logalty-digital-signature/digital-signature-service/digital-signature-service.store';
import { ThirdPartySignatureResponseDTO } from '@app/requests/model/logalty-signature-model';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-third-party-signature',
  templateUrl: './third-party-signature.component.html',
  styleUrls: ['./third-party-signature.component.scss'],
})
export class ThridPartySignatureComponent implements OnInit {
  public responseOK: boolean = false;
  public responseConsentsOK: boolean = false;
  public url: string = '';
  public language: string = '';
  public logo: string = null;
  public name: string = '';
  private code: string;

  isDocumentResultValid: boolean = false;

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public translate: TranslateService,
    public dialog: MatDialog,
    private readonly loaderGenericService: LoaderGenericService,
    private readonly digitalSignatureServiceStore: DigitalSignatureServiceStore,
    private readonly detectDeviceService: DetectDeviceService,
    private readonly changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.loaderGenericService.showSpinner();
    this.url = window.location.href;
    this.code = this.url.split('logalty-signature-thirdParty/')[1];
    localStorage.setItem('ThirdPartyCode', this.code);
    this.digitalSignatureServiceStore.getSAMLThirdParty(this.code).then(
      (data: ThirdPartySignatureResponseDTO) => {
        if (data) {
          this.digitalSignatureServiceStore.setSAMLdata({ saml: data?.samlResponse });
          this.name = data?.companyName;
          this.language = data?.language;
          this.logo = data?.companyLogo;
          this.responseOK = true;
          this.reinitChildComponent();
          this.loaderGenericService.stopSpinner();
        } else {
          const dialogConfig = new MatDialogConfig();
          dialogConfig.data = {
            text: this.translate.instant('logalty.error.firmaNoPermitida'),
            icon: 'icon-ic_circle_cross',
            buttonCancel: false,
          };
          this.dialog.open(ResponseDialogComponent, dialogConfig);
        }
      },
      (_error) => {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.data = {
          text: this.translate.instant('logalty.error.firmaNoPermitida'),
          icon: 'icon-ic_circle_cross',
          buttonCancel: false,
        };
        this.dialog.open(ResponseDialogComponent, dialogConfig);
      }
    );
  }

  reinitChildComponent(): void {
    this.changeDetectorRef.detectChanges();
  }
}
